module.exports = __webpack_public_path__ + "static/img/img_ser_eiou.9709811.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_ser_eiou.png
// module id = nvgs
// module chunks = 1